module.exports = __webpack_public_path__ + "img/C534.9512d219.jpg";